import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { TemplateService } from "./template.service";

@Injectable({
  providedIn: 'root'
})

export class EcommerceService {
  constructor(
    private http: HttpClient,
    private templateService: TemplateService
  ) {}

  async getDummyData(subIndustryId: any, sectionType: any) {
    if (sectionType === 'productList' || sectionType === 'featuredProduct') {
      try {
        const res = await lastValueFrom(this.templateService.getDummyProductList(subIndustryId));
        return res;
      } catch (error) { }
    }
    if (sectionType === 'featuredCategory') {
      try {
        const res = await lastValueFrom(this.templateService.getDummyCategory(subIndustryId));
        return res;
      } catch (error) { }
    }
    if (sectionType === 'productDescription') {
      try {
        const res = await lastValueFrom(this.templateService.getDummyProduct(subIndustryId));
        return res;
      } catch (error) { }

    }
    if(sectionType === 'cart') {
      try {
        const res = await lastValueFrom(this.templateService.getDummyProduct(subIndustryId));
        return res;
      } catch (error) { }
    }
    return null;
  }
}
